import axios from "../utils/axios.wrapper";

export const getGroups = async () => {
  const { data } = await axios.get("/group");
  // Backend returns { items: [], totalCount: N }
  return data.items || data;
};

export const getActiveGroups = async () => {
  const { data } = await axios.get("/group/active");
  // Backend returns { items: [], totalCount: N }
  return data.items || data;
};

export const getInactiveGroups = async () => {
  const { data } = await axios.get("/group/inactive");
  // Backend returns { items: [], totalCount: N }
  return data.items || data;
};

export const getGroupById = async (id) => {
  const { data } = await axios.get(`/group/${id}`);
  return data;
};

export const createGroup = async (group) => {
  const { data } = await axios.post("/group/create", group);
  return data;
};

export const updateGroup = async (id, group) => {
  const { data } = await axios.put(`/group/${id}`, group);
  return data;
};

export const deleteGroup = async (id) => {
  const { data } = await axios.delete(`/group/${id}`);
  return data;
};

export const hardDeleteGroup = async (id) => {
  const { data } = await axios.delete(`/group/hard/${id}`);
  return data;
};

export const importGroups = async (file) => {
  const formData = new FormData();
  formData.append('File', file);
  const { data } = await axios.post("/group/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const downloadGroupTemplate = async () => {
  const response = await axios.get("/group/download-template", {
    responseType: 'blob',
  });
  return response;
};

export const groupService = {
  getGroups,
  getActiveGroups,
  getInactiveGroups,
  getGroupById,
  createGroup,
  updateGroup,
  deleteGroup,
  hardDeleteGroup,
  importGroups,
  downloadGroupTemplate,
};